export enum DeliveryOptionsEnum {
  Jnt = 'J&T',
  TechOut = 'Tech Out',
  TechOutFree = "Tech Out - Free",
  PickUp = "Pickup",
}
